import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import ReactConfetti from "react-confetti";

import styled from "styled-components/macro";

Confetti.propTypes = {
  hide: PropTypes.bool,
};

export default function Confetti({ hide }) {
  const [measurements, setMeasurements] = useState(false);

  const callBackRef = useCallback((domNode) => {
    if (domNode) {
      const { width, top } = domNode.getBoundingClientRect();
      setMeasurements({ width, height: window.innerHeight - top });
    }
  }, []);

  if (hide) return null;

  return (
    <Wrapper ref={callBackRef}>
      {measurements && (
        <ReactConfetti
          width={measurements.width}
          height={measurements.height}
          recycle={false}
          numberOfPieces={250}
          tweenDuration={15000}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;
